import * as React from 'react';

const SectionLeftFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M4 20h8v-4H4v4zM4 10v4h16v-4H4zM4 4v4h16V4H4z"
        />
    </svg>
);

SectionLeftFillSvg.displayName = 'SectionLeftFillSvg';
export default SectionLeftFillSvg;
